export default __webpack_public_path__ + "static/hello-expandedMemory-d737c54d8dde82e7b899b1d2174d1f39.jpg";